import { useCallback, useEffect, useState } from 'react';
import { getFlujosVariedadesNav } from '../services/apis';
import { normalizeFlujosVariedadesNav } from '../utils/flujosCatalogsMapper';

const buildErrorMessage = (error) => {
  const message = error?.response?.data?.message || error?.message;

  if (Array.isArray(message)) {
    return message.join(', ');
  }

  return message || 'No se han podido cargar las variedades de NAV.';
};

export const useFlujosVariedadesNav = () => {
  const [state, setState] = useState({ rows: [], loading: true, error: '' });

  const fetchVariedades = useCallback(async () => {
    setState((current) => ({ ...current, loading: true, error: '' }));

    try {
      const response = await getFlujosVariedadesNav();
      setState({
        rows: normalizeFlujosVariedadesNav(response),
        loading: false,
        error: '',
      });
    } catch (error) {
      setState({ rows: [], loading: false, error: buildErrorMessage(error) });
    }
  }, []);

  useEffect(() => {
    fetchVariedades();
  }, [fetchVariedades]);

  return { ...state, refetch: fetchVariedades };
};
